import { EnvModeType } from '@app/enums/env-mode-type.enum';
import { ServiceLineType } from '@app/enums/service-type.enum';
import {
    AccessRoleType,
    SupplyChainAccessRoleType,
} from '@app/modules/user-management/enums/access-role-type.enum';
import { IEnvironment } from './environment.i';

export const environment: IEnvironment = {
    production: false,
    providers: [],
    languageBaseUrl: 'https://dev.rcp.ulplatform.com/assets/i18n/{0}.json',
    defaultLanguage: 'en-US',
    msalConfig: {
        auth: {
            authority:
                'https://testulplatform.b2clogin.com/testulplatform.onmicrosoft.com/B2C_1A_Signup_Signin_Staging',
            clientId: '109e180b-95d6-4b42-aac6-4be4ab15f11d',
            knownAuthorities: ['testulplatform.b2clogin.com'],
            redirectUri: 'https://dev.myul.ulplatform.com/rcp/callback',
        },
    },
    apiConfig: {
        scopes: {
            read: ['https://testulplatform.onmicrosoft.com/rcp-api-dev/read'],
            write: ['https://testulplatform.onmicrosoft.com/rcp-api-dev/write'],
        },
        uri: 'https://dev.rcp.ulplatform.com/api/v1.0',
    },
    apiEndpoint: 'https://dev.rcp.ulplatform.com/api/',
    nextGenApiEndpoint: 'https://dev.myul.ulplatform.com/api/',
    mode: EnvModeType.DEV,
    accessRoles: {
        [AccessRoleType.AccountManager]: 'Account Manager',
        [AccessRoleType.SA]: 'Super User',
        [AccessRoleType.CompanyAdmin]: 'Company Admin',
        [AccessRoleType.CompanyUser]: 'Company User',
        [AccessRoleType.CompanyPrimaryAdmin]: 'Company Primary Admin',
    },
    supplyChainAccessRoles: {
        [SupplyChainAccessRoleType.Client]: 'Client',
        [SupplyChainAccessRoleType.Vendor]: 'Vendor',
    },

    serviceLines: {
        [ServiceLineType.Testing]: 'Testing',
        [ServiceLineType.Inspection]: 'Inspection',
        [ServiceLineType.Audit]: 'Audit',
    },

    links: {
        loginUrl: 'https://dev.myul.ulplatform.com/home',
        eformsUrl: 'https://qaeforms.ul.com/rcpportalform',
    },
    countDownWarningTimeOut: 60, //seconds
    idleTimeOut: 60, //seconds
    inspectionMaxCompletedRows: 100,
    metroSourceMinDateAllowed: 'January 7, 2025',
    defaultUrl: 'https://dev.rcp.ulplatform.com/',
    appInsights: {
        key: '06485f78-e900-42d8-992a-feb2cb1648ec',
        enableTracking: true,
    },
    salt: 'OTA0MTQ5bW1RUTU4ODI5NjQwNTlGMkRDNzNEQjcyM2NAODdEQTM4JEV4Q3o2NjhENTdFQg==',
    appStoreKey: 'MEU2RkI5Q0I0LTE0MjgtNEJFMS1CMzg5LTkxRjczOTA2MUJCNg==',
    agGridLicenseKey:
        'Using_this_{AG_Grid}_Enterprise_key_{AG-080316}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{UL_Solutions}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{26_May_2026}____[v3]_[01]_MTc3OTc1MDAwMDAwMA==da157bf4bab78772667cd056fd452ce6',
};
